import React from "react";
import { Container } from "reactstrap";
import TableCurrentCash from "./tableCurrentCash";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NotaDatoOriginal from "../../components/Common/NotaDatoOriginal";

const Cash = () => {
  document.title = "Caja | TicketControl";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="TicketControl" breadcrumbItem="Caja" />
          <TableCurrentCash />
          <NotaDatoOriginal />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Cash;
